import type {State} from '@/redux/typesNew';

import {offersState} from '@/redux/v1/v1State';

export const listState = (state: State) => offersState(state).list;
export const inventoryState = (state: State) => offersState(state).inventory;
